import { SPORT_CATEGORY } from "@/utils/sports";

// The virtual sports served by provider 8 (Sportradar VFL / VBL). Every
// virtualSport API call and query takes one of these; the default keeps every
// existing (football-only) caller unchanged.
export type VirtualSportType =
  | typeof SPORT_CATEGORY.VirtualFootball
  | typeof SPORT_CATEGORY.VirtualBasketball;

export const DEFAULT_VIRTUAL_SPORT_TYPE: VirtualSportType =
  SPORT_CATEGORY.VirtualFootball;

// sinek-api passthrough base per sport (/match-streams/virtual/* = VFL,
// /match-streams/virtual-basketball/* = VBL). Same endpoint names under both.
const VIRTUAL_STREAM_BASE: Record<VirtualSportType, string> = {
  [SPORT_CATEGORY.VirtualFootball]: "/match-streams/virtual",
  [SPORT_CATEGORY.VirtualBasketball]: "/match-streams/virtual-basketball",
};

export type VirtualStreamEndpoint =
  | "rounds"
  | "round"
  | "standings"
  | "timing"
  | "resolve";

export const virtualStreamPath = (
  sportType: VirtualSportType,
  endpoint: VirtualStreamEndpoint
): string => `${VIRTUAL_STREAM_BASE[sportType]}/${endpoint}`;
